export type ModalType = {
  value: string;
  key: string;
};
export const MODAL_TYPES: {
  GIFT_CARD_NOT_FOUND: ModalType;
  GIFT_CARD_INSUFFICIENT_FUNDS: ModalType;
  GIFT_CARD_REMOVE_CONFIRMATION: ModalType;
  GIFT_CARD_GENERIC_ERROR: ModalType;
} = {
  GIFT_CARD_NOT_FOUND: {
    value: 'gift-card-not-found',
    key: 'notFound',
  },
  GIFT_CARD_INSUFFICIENT_FUNDS: {
    value: 'gift-card-insufficient-funds',
    key: 'insufficientFunds',
  },
  GIFT_CARD_REMOVE_CONFIRMATION: {
    value: 'gift-card-remove-confirmation',
    key: 'removeConfirmation',
  },
  GIFT_CARD_GENERIC_ERROR: {
    value: 'gift-card-generic-error',
    key: 'generic',
  },
};
